module.exports = __webpack_public_path__ + "static/media/2 Blue.98cbf3df.svg";